import React, { Component } from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink, Button } from 'reactstrap';

import { TransitionGroup, CSSTransition } from "react-transition-group";

import classNames from 'classnames';
import RearrengeItem from './rearrenge-item'

class Rearrenge extends Component{

  constructor(props) {
    super(props)

    this.state = {
      activeTab: 1,
      old_group_item: null,
      new_group_item: null,
    }

    this.toggle = this.toggle.bind(this);
    this.moveToGropu = this.moveToGropu.bind(this);
    this.onExitTransition = this.onExitTransition.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
  }

  toggle = (tab) => {
    const { activeTab } = this.state
    if ( activeTab !== tab )
      this.setState({ activeTab: tab })
  }

  moveToGropu = ( item_id,value ) => {
    const { response_list, hanndleResponse } = this.props
    const old_group_item = response_list.get(item_id)
    const new_group_item = { item_id,value }
    this.setState({ old_group_item, new_group_item })
  }

  onExitTransition = (e) =>{
    const { response_list, hanndleResponse } = this.props
    const { old_group_item, new_group_item } = this.state
    if (new_group_item){
      this.setState({ new_group_item:null })
      hanndleResponse( new_group_item.item_id, new_group_item.value)
    }
  }

  componentDidUpdate(oldProps,oldState) {
    const { hanndleResponse } = this.props
    const { old_group_item, new_group_item } = this.state
    if (!new_group_item && oldState.new_group_item) {

      this.setState({ old_group_item:null })
    }
  }

  handleDragOver(e, group) {
    e.preventDefault();
  }

  handleDrop(e, group_value) {
    e.preventDefault();
    const id = +e.dataTransfer.getData('id');
    const current_value = +e.dataTransfer.getData('value');
    
    if(group_value === current_value) {
      return
    }

    this.moveToGropu(id, String(group_value))
}

  render() {
    const { hanndleNextQuestion,  items, response_range, questions, hanndleResponse, validations } = this.props
    const { activeTab, old_group_item } = this.state
 
    const animationClass = {
      appearActive: 'animate__animated animate__slideInRight',
      enter: 'animate__animated slideDown',
      enterActive: 'animate__animated animate__slideInRight',
      exit: 'animate__animated slideUp',
      exitActive: 'animate__animated animate__slideOutLeft',
      appear: 'animate__animated',
    }

    /*-------------------*/
    const filteredGroups = Object.entries(validations).filter(([key, value]) => key.startsWith('group_')).reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

    const rangeGroup = []
    response_range.forEach((value, key) => {
      rangeGroup[`range_group_${key}`] = value;
    });

    const talents = Object.keys(filteredGroups).reduce((result, groupKey) => {
        const rangeKey = `range_${groupKey}`; 
        result[groupKey] = {
            ...filteredGroups[groupKey], 
            range: rangeGroup[rangeKey],
            items: items[groupKey],
        };
        return result;
    }, {});

    /*--------------------*/
    const mapGroupItems = (group, groupNumber, groupName) => {
      return group.map(item => {
        if (old_group_item && old_group_item.item_id === item.item_id && old_group_item.value === String(groupNumber)) {
          return null;
        }
    
        return (
          <CSSTransition onExited={this.onExitTransition} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} key={`${groupNumber}_${item.item_id}`}>
            <RearrengeItem data={item} questions={questions} hanndleResponse={this.moveToGropu} name={groupName} />
          </CSSTransition>
        );
      });
    };

    return (
      <>
        <div>
          <div className='mb-3 pt-4'>
            <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Review & Rearrange</h1>
            <p className='d-none d-lg-block'>Drag and drop talent to change your answer.</p>
            <p className='d-block d-lg-none'>Tap on a talent to change your answer.</p>
          </div>

          <div className="content-rearrenge border rounded border-md-0 pb-3 mb-3">
            <Nav className="d-lg-none d-flex justify-content-between" tabs>
              {Object.entries(talents).map(([key, group], index) => (
                <NavItem key={index}>
                  <NavLink className={classNames({ active: activeTab === (index+1) }, 'text-capitalize')} onClick={() => { this.toggle((index+1)); }}>
                      {group.name}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>

            <TabContent activeTab={activeTab} className="content-rearrenge-tabContent border-transparent">
            {Object.entries(talents).map(([key, group], index) => (
              <TabPane key={index} className="content-rearrenge-tab" tabId={index+1} onDrop={(e) => this.handleDrop(e, index+1)} onDragOver={(e) => this.handleDragOver(e, index+1)}>
                <div key={key} id={key} className="p-2 p-lg-4 d-inline-block border-lg rounded w-100">
                  <div className="header-group">
                    <h2 className='font-weight-semibold h5'><i className={`dot border border-${group.name} bg-${group.name === 'sometimes' ? 'transparent' : group.name}`}></i><span className='text-capitalize'>{group.name}</span> <span className={`${!group.valid ? 'text-danger' : ''}`}>({group.items.size})</span></h2>
                    {!group.valid && <p className="text-danger line-height-normal small mb-0">Number of talents in “<span className='text-capitalize'>{group.name}</span>” should be minimum { group.range.min } and maximum { group.range.max }.</p>}
                  </div>
                  <div className='overflow-hidden' >
                    <TransitionGroup className="group">
                      {mapGroupItems(items[key], (index+1), group.name)}
                    </TransitionGroup>
                  </div>
                </div>
              </TabPane>
            ))}
            </TabContent>
          </div>

          <Button color='green-light' size='sm' disabled={!validations.valid} onClick={() => hanndleNextQuestion('result', validations.valid)} className="d-block mx-auto mb-3">
            Finish sorting 
            <i className='ml-1'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
              </svg>
            </i>
          </Button>
        </div>
      </>
    )
  }
}

export default Rearrenge;
